import { render } from "./HubspotCard.vue?vue&type=template&id=220d1a5f&scoped=true"
import script from "./HubspotCard.vue?vue&type=script&lang=js"
export * from "./HubspotCard.vue?vue&type=script&lang=js"

import "./HubspotCard.vue?vue&type=style&index=0&id=220d1a5f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220d1a5f"]])

export default __exports__